<template>
	<!-- 基本信息 -->
	<div class="Minister-top information">
		<div class="Minister-top-top Ministerbackground">
			<div class="Minister-top-left Minister-top-color">店铺和类目</div>
		</div>
		<div class="information_content">
			<div class="information_input" style="margin-bottom:20px;" >
				<div class="information_Title">
					<span class="tips">*</span>
					店铺
				</div>
				<div class="input_el input_span">
					<div class="newipt" style="display: flex;">
						<el-select
								v-model="formData.sellerId"
								class="width67 "
								placeholder="请选择"
								@change="selectChange"
								:disabled="onlineEdit || system < 5 ||isChakan"
						>
							<el-option
									v-for="item in dianpuList"
									:key="item.sellerId"
									:label="item.shopName"
									:value="item.sellerId"
							></el-option>
						</el-select>
						<div v-if="isShowCount" style="margin-left: 10px;display: flex;align-items: center;background:rgb(255,183,82);padding: 0 10px;border-radius: 5px ">店铺限额：{{sellCount}} <span style="margin-left: 10px">已使用：{{usage}}</span></div>
					</div>
				</div>
			</div>
			<div class="information_input" style="margin-bottom:20px;" >
				<div class="information_Title">
					<span class="tips">*</span>
					平台分类
				</div>
				<div class="input_el input_span">
					<div class="newipt">
						<el-input
								class="width67"
								v-model="allLeimuName"
								maxlength="20"
								disabled
								@blur="blurLeimu()"
						></el-input>
						<el-button style="margin-left: 10px" type="primary" @click="selectLeimu" v-if="!onlineEdit && !isChakan"
								   :disabled="system < 5 || isChakan">选择类目</el-button>
					</div>
				</div>
			</div>
			<div class="information_input" style="margin-bottom:20px;" >
				<div class="information_Title">
					<span class="tips">*</span>
					ParentSKU
				</div>
				<div class="input_el input_span">
					<div class="newipt">
						<el-input
								class="width67"
								v-model="formData.sku"
								@input="inputSkuchange"
								:disabled="addStatus == 'edit' || system < 5 || isEditLeimu ||isChakan"
						></el-input>
						<el-button style="margin-left: 10px" type="primary" @click="createSku" v-if="addStatus != 'edit' && !isEditLeimu &&  !isChakan" :disabled="system < 5">生成编号</el-button>
					</div>
				</div>
			</div>

			<div
					class="information_input"
					style="margin-bottom:20px;"
			>
				<div class="information_Title">
					<span class="tips">*</span>
					标题
				</div>
				<div class="input_el input_span">
					<div class="newipt">
						<el-input
								type="text"
								class="width85"
								v-model="formData.name"
								maxlength="500"
								show-word-limit
								:disabled="system < 5 || isChakan"
								@input="inputNamechange"
						>
						</el-input>
						<el-tooltip placement="right-start"  effect="light" :open-delay="300" v-if="system == 5 && !isChakan">
							<template slot="content">
								首字母大写
							</template>
							<el-button style="background: rgb(245,245,245);color: #b7b4b4" type="primary" @click="capitalizeFirstLetter">A a</el-button>
						</el-tooltip>
					</div>
					<div style="margin-top: 5px">
						使用俄文，推荐格式: 类目+品牌（如有品牌）+名称+变体属性，标题过长或重复单词可能导致审核失败
					</div>
				</div>
			</div>	<div
				class="information_input"
				style="margin-bottom:20px;"
		>
			<div class="information_Title">
				产品属性
			</div>
			<div class="shuxing_box">
				<div class="item_shuxing" v-for="(item,index) in topAttributeList" :key="index">
					<div class="shuxing_label">
						<span class="shuxing_label_bitian" v-if="item.isRequired == 1">*</span>
						{{item.name}}（{{item.nameCn}})
						<el-tooltip placement="right-start" v-if="item.descriptionCn">
							<div slot="content" class="el_tip_box">
								{{item.descriptionCn}}
							</div>
							<img :src="urlQueImg" class="item_img" alt/>
						</el-tooltip>
					</div>
					<div v-if="item.type != 'Boolean'" style="width: 40%">
						<div v-if="item.dictionaryId == 0" style="width: 100%">
							<!--只能输入数字-->
							<el-input v-if="item.type == 'Integer'" class="shuxing_input" v-model="item.fieldValue"  oninput ="value=value.replace(/[^0-9]/g,'')"
									  :disabled="item.attributeId == 31 ||item.attributeId == 33 ||item.attributeId == 85 || system < 5 || isChakan">
							</el-input>
							<!--只能输入数字 小数点-->
							<el-input v-else-if="item.type == 'Decimal'" class="shuxing_input" v-model="item.fieldValue"  oninput ="value=value.replace(/[^0-9.]/g,'')"
									  :disabled="item.attributeId == 31 ||item.attributeId == 33 ||item.attributeId == 85 || system < 5 || isChakan">
							</el-input>
							<el-input v-else class="shuxing_input" v-model="item.fieldValue"
									  :disabled="item.attributeId == 31 ||item.attributeId == 33 ||item.attributeId == 85 || system < 5 || isChakan">
							</el-input>
						</div>
						<el-select filterable  v-if="item.dictionaryId != 0" :multiple="item.isCollection == 1" :disabled="item.attributeId == 31 ||item.attributeId == 33 ||item.attributeId == 85 || system < 5 || isChakan"
								   v-model="item.fieldValue"  class="shuxing_select" clear  filterable
						>
							<el-option
									v-for="itemselect in item.attributeValues"
									:key="itemselect.valueId"
									:label="itemselect.valueCn"
									:value="itemselect.value"
							></el-option>
						</el-select>
					</div>
					<div v-if="item.type == 'Boolean'" style="width: 40%">
						<el-radio-group v-model="item.fieldValue" :disabled="item.attributeId == 31 ||item.attributeId == 33 ||item.attributeId == 85 || system < 5 || isChakan">
							<el-radio :label="true">是</el-radio>
							<el-radio :label="false">否</el-radio>
						</el-radio-group>
					</div>

					<div style="height: 100%;display: flex;align-items: center" v-if="system == 5 && !isChakan">
						<el-button  icon="el-icon-plus" class="shuxing_button" @click="addToBianti(item,index)" v-if="item.attributeId != 31 && item.attributeId != 33 && item.attributeId != 85 && !onlineEdit"></el-button>
					</div>
				</div>
			</div>
		</div>
		</div>
		<el-dialog
				title="分类选择"
				:visible.sync="leimuDialog"
				append-to-body
				width="1300px"
				top="10vh">
			<div style="display: flex;width: 100%">
				<el-input
						v-model="formData.searchName"
						placeholder="搜索分类名称"
						style="margin-right: 20px"
						@change="searchFenlei"

				></el-input>
				<el-button type="primary"  @click="searchFenlei">搜 索</el-button>
				<el-button type="primary" @click="resetFenlei">重 置</el-button>
			</div>
			<div v-if="!isSearch" style="display: flex;align-items: center;height: 32px;background:rgba(255,244,240,1);font-size: 14px;border: 1px solid indianred;color: indianred;margin-top: 10px;padding-left: 10px">
				<span>当前所选类目是：{{allLeimuName}}</span>
			</div>
			<div class="search_box" v-if="!isSearch">
				<div class="search_box_item">
					<el-input v-model="leimuValue1" size="medium"
							  @input="changeLeimu1" ></el-input>
					<div class="leimu_box">
						<div :class="selectdescId1 == item.descriptionCategoryId ? 'select_leimu':''" class="leimu_item" v-for="(item,index) in leimuList1" :key="index" @click="clickLeimu1(item)">
							<div class="leimu_item_desc">{{item.categoryName}}({{item.categoryNameCn}})</div>
							<i class="el-icon-d-arrow-right item_leimu_you"></i>
						</div>

					</div>
				</div>
				<div class="search_box_item">
					<el-input v-model="leimuValue2" size="medium"
							  @input="changeLeimu2" ></el-input>
					<div class="leimu_box">
						<div :class="selectdescId2 == item.descriptionCategoryId ? 'select_leimu':''" class="leimu_item" v-for="(item,index) in leimuList2" :key="index" @click="clickLeimu2(item)">
							<div class="leimu_item_desc">{{item.categoryName}}({{item.categoryNameCn}})</div>
							<i class="el-icon-d-arrow-right item_leimu_you"></i>
						</div>
					</div>
				</div>
				<div class="search_box_item">
					<el-input v-model="leimuValue3" size="medium"
							  @input="changeLeimu3" ></el-input>
					<div class="leimu_box">
						<div :class="selectdescId3 == item.typeId ? 'select_leimu':''" class="leimu_item" v-for="(item,index) in leimuList3" :key="index" @click="clickLeimu3(item)">
							<div class="leimu_item_desc">{{item.typeName}}({{item.typeNameCn}})</div>
						</div>
					</div>
				</div>
			</div>
			<div class="search_box2" v-if="isSearch">
				<div style="width: 100%">
					<div class="leimu_box2">
						<div :class="selectdescId4 == item.descriptionCategoryId ? 'select_leimu':''" class="leimu_item" v-for="(item,index) in leimuList4" :key="index" @click="clickLeimu4(item)">
							<div class="leimu_item_desc" v-html="`${item.fullCategoryNameCn} - ${item.fullCategoryName}`"></div>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" style="margin-top: 60px">
					<el-button  @click="leimuDialog = false">取 消</el-button>
					<el-button type="primary" @click="handleSelectleimu" :disabled="!parentDescriptionCategoryId">选 择</el-button>
  		</span>
		</el-dialog>
	</div>
</template>
<script>
	import {ajaxGet, ajaxPost, Baseurl} from "../../../../api/api/api";
	export default {
		name: 'baseInfoComp',
		props: {
			score: {
				type: Array,
				default() {
					return [0,0,0,0];
				},
			}
		},
		data() {
			return {
				changeFenleiTime:0,
				system:5,
				//在线产品编辑
				onlineEdit:false,
				//是否为查看
				isChakan:false,
				addStatus:'add',//判断是新增还是编辑
				isEditLeimu:false,//编辑状态修改了类目
				biaotiComplexId4191:'',
				biaotiComplexId13164:'',
				biaotiComplexId11254:'',
				biaotiComplexId21837:'',
				biaotiComplexId21841:'',
				biaotiComplexId21845:'',
				biaotiComplexId4180:'',
				biaotiComplexId9048:'',
				biaotiComplexId8292:'',
				attr9048:undefined,
				attr8292:undefined,
				//角色id
				staffId:'',
				//问号图标的地址
				urlQueImg:require('@/assets/images/wenhao.png'),
				//原始的属性数组
				oldAttributeList:[],
				//上面的属性数组
				topAttributeList:[],
				//变体的属性数组
				bottomAttributeList:[],
				//第三级选中的parentDescriptionCategoryId
				parentDescriptionCategoryId:'',
				typeId:'',
				//是否为点击搜索状态
				isSearch:false,
				//当前所选类目名称
				allLeimuName:'',
				leimuDialog:false,
				//店铺限额数量
				sellCount:0,
				//已使用
				usage:0,
				//是否显示店铺限额
				isShowCount:false,
				//店铺List
				dianpuList:[],
				//类目
				leimuList1:[],
				leimuList2:[],
				leimuList3:[],
				leimuList4:[],
				oldleimuList1:[],
				oldleimuList2:[],
				oldleimuList3:[],
				leimuValue1:'',
				leimuValue2:'',
				leimuValue3:'',
				seletObj1:{},
				seletObj2:{},
				seletObj3:{},
				selectdescId1:'',
				selectdescId2:'',
				selectdescId3:'',
				selectdescId4:'',
				branchCompany: [],
				//问号图标的地址
				urlQueImg:require('@/assets/images/wenhao.png'),
				formData:{
					//店铺id
					sellerId:'',
					shopId:undefined,
					//商品类型id
					typeId:'',
					//分类id
					categoryId:'',
					//parentSku
					sku:'',
					changkuangao:'0',
					//类目id
					dictionary_id:'',
					searchName:'',
					name:''//标题
				},

			}
		},
		created() {
			this.system = JSON.parse(localStorage.getItem('role')).system
			this.staffId = JSON.parse(localStorage.getItem('role')).rid
		},
		methods: {
			getdianpuList(params){
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', params).then((res) => {
					var sellerInfos = res.data.data.next
					var newArr = []
					var num = 0
					for (var i = 0; i < sellerInfos.length; i++) {
						var shop = sellerInfos[i].countryMarks
						var sellerId = sellerInfos[i].sellerId;
						var currencyCode = sellerInfos[i].currencyCode;
						for (var j = 0; j < shop.length; j++) {
							shop[j].sellerId = sellerId;
							shop[j].currencyCode = currencyCode;
							newArr[num] = shop[j]
							// newArr[num] = shop[j];
							num++
						}
					}
					this.dianpuList = newArr
				})
			},
			//创建，获取店铺列表
			setDianpuList(arr){
				this.dianpuList = arr
				this.formData.sellerId = undefined
				this.isShowCount = false
				this.allLeimuName = undefined
				this.formData.sku = undefined
				this.formData.name = undefined
				this.oldAttributeList = []
				this.topAttributeList = []
				this.bottomAttributeList = []
				this.formData.searchName = undefined
				this.leimuValue1 = undefined
				this.selectdescId1 = undefined
				this.leimuValue2 = undefined
				this.selectdescId2 = undefined
				this.leimuValue3 = undefined
				this.selectdescId3 = undefined
				this.isSearch = false
				this.selectdescId4 = undefined
				this.leimuDialog = false
			},
			formatInputValue(value) {
			},
			//类目id失去焦点,根据类目id自动匹配类目
			blurLeimu(value){
				// if (value){
				// 	const API = Baseurl + 'ozonCategoryController/ozon/getCategoryByTypeId/' + value
				// 	ajaxGet(API)
				// 			.then((res) => {
				// 				if (res.data.code == 200) {
				// 					if (res.data.data.typeId){
				// 						this.formData.typeId = res.data.data.typeId
				// 						//一共的名称
				// 						this.formData.allTypeName = res.data.data.typeId + '(ID),'+ res.data.data.typeName+ '('+res.data.data.typeNameCn + ')'
				// 					}
				// 				} else {
				// 					this.$message.error(res.data.message)
				// 				}
				// 			})
				// }

			},
			//点击选择店铺，获取店铺限额
			selectChange(val){
				let shopId = '';
				let currencyCode = '';
				for(let i = 0; i < this.dianpuList.length; i++){
					if(this.dianpuList[i]['sellerId'] == val){
						currencyCode = this.dianpuList[i]['currencyCode'];
						shopId = this.dianpuList[i]['sellerId'];
					}
				}
				this.formData.shopId = shopId;
				this.$emit('changeCurrencyCode', currencyCode)
				if (val){
					const API = Baseurl + '/ozonProduct/getOzonProductInfoLimit'
					let paramsData = {
						sellerId:val
					}
					ajaxPost(API, paramsData)
							.then((res) => {
								if(res.data.code === 200) {
									this.sellCount = (res.data.data && res.data.data.total && res.data.data.total.limit) ? res.data.data.total.limit : '0'
									this.usage = (res.data.data && res.data.data.total && res.data.data.total.usage) ? res.data.data.total.usage : '0'

									this.isShowCount = (res.data.data && res.data.data.total && res.data.data.total.limit && res.data.data.total.usage) ? true : false
								}else{
									this.$message.error(res.data.data)
									this.isShowCount = false
								}
							})
					//通过商铺id获取仓库list
					const API2 = Baseurl + 'ozonProduct/getOzonWarehouseList'
					ajaxPost(API2, {sellerId: val}).then((res) => {
						const { code, data } = res.data
						if (code === 200) {
							this.$emit('editCangku', data)
						}
					})
				}
			},
			addToBianti(item,index){
				this.topAttributeList.splice(index,1)
				//父组件添加变体属性
				this.$emit('addToBianti', item)
			},
			//选择类目 根据parentId 获取下级分类
			selectLeimu(){
				this.leimuDialog = true
				this.parentDescriptionCategoryId = ''
				this.typeId = ''
				this.getCategoryByParentId(0,1)
			},
			getCategoryByParentId(id,level){
				const API = Baseurl + 'ozonCategoryController/ozon/getCategoryByParentId/' + id
				ajaxGet(API)
						.then((res) => {
							if (res.data.code == 200) {
								this.parentDescriptionCategoryId = ''
								this.typeId = ''
								//一级
								if (level == 1) {
									this.leimuValue1 = ''
									this.selectdescId1 = ''
									this.seletObj1 = {}
									this.leimuList2 = []
									this.oldleimuList2 = []
									this.leimuValue2 = ''
									this.selectdescId2 = ''
									this.seletObj2 = {}
									this.leimuList3 = []
									this.oldleimuList3 = []
									this.leimuValue3 = ''
									this.selectdescId3 = ''
									this.seletObj3 = {}
									this.oldleimuList1 = res.data.data
									this.leimuList1 = res.data.data
									//2级
								} else if(level == 2) {
									this.leimuValue2 = ''
									this.selectdescId2 = ''
									this.seletObj2 = {}
									this.leimuList3 = []
									this.oldleimuList3 = []
									this.leimuValue3 = ''
									this.selectdescId3 = ''
									this.seletObj3 = {}
									this.oldleimuList2 = res.data.data
									this.leimuList2 = res.data.data

									//3级
								}  else if(level == 3) {
									this.leimuValue3 = ''
									this.selectdescId3 = ''
									this.seletObj3 = {}
									this.oldleimuList3 = res.data.data
									this.leimuList3 = res.data.data
								}
							} else {
								this.$message.error(res.data.message)
							}
						})
			},
			clickLeimu1(item){
				this.selectdescId1 = item.descriptionCategoryId
				this.parentDescriptionCategoryId = ''
				this.typeId = ''
				this.seletObj1 = item
				this.leimuList2 = []
				this.leimuValue2 = ''
				this.selectdescId2 = ''
				this.seletObj2 = {}
				this.leimuList3 = []
				this.leimuValue3 = ''
				this.selectdescId3 = ''
				this.seletObj3 = {}
				this.getCategoryByParentId(item.descriptionCategoryId,2)
				this.setAllLeimuName(1)
			},
			clickLeimu2(item){
				this.selectdescId2 = item.descriptionCategoryId
				this.seletObj2 = item
				this.leimuList3 = []
				this.leimuValue3 = ''
				this.selectdescId3 = ''
				this.seletObj3 = {}
				this.getCategoryByParentId(item.descriptionCategoryId,3)
				this.parentDescriptionCategoryId = ''
				this.typeId = ''
				this.setAllLeimuName(2)
			},
			clickLeimu3(item){
				this.seletObj3 = item
				this.selectdescId3 = item.typeId
				this.parentDescriptionCategoryId = item.parentDescriptionCategoryId
				this.typeId  = item.typeId
				this.formData.categoryId = item.parentDescriptionCategoryId
				this.formData.typeId = item.typeId
				if (this.addStatus == 'edit'){
					this.isEditLeimu = true
				}
				this.$emit('resetBianti')
				this.setAllLeimuName(3)
			},
			//选中搜索内容
			clickLeimu4(item){
				this.allLeimuName = item.fullCategoryName + '('+ item.fullCategoryNameCn+ ')'
				this.formData.categoryId = item.parentDescriptionCategoryId
				this.formData.typeId = item.typeId
				this.leimuDialog = false
				if (this.addStatus == 'edit'){
					this.isEditLeimu = true
				}
				this.$emit('resetBianti')
				this.getAttribute()
			},
			changeLeimu1(val){
				let leimuList = JSON.parse(JSON.stringify(this.oldleimuList1))
				if (val){
					this.leimuList1 = leimuList.filter(item =>{
						return (item.categoryName.indexOf(val) > -1 || item.categoryNameCn.indexOf(val) > -1)
					})
					this.selectdescId1 = ''
					this.seletObj1 = {}
				} else {
					this.leimuList1 = leimuList
				}
			},
			changeLeimu2(val){
				let leimuList = JSON.parse(JSON.stringify(this.oldleimuList2))
				if (val){
					this.leimuList2 = leimuList.filter(item =>{
						return (item.categoryName.indexOf(val) > -1 || item.categoryNameCn.indexOf(val) > -1)
					})
					this.selectdescId2 = ''
					this.seletObj2 = {}
				} else {
					this.leimuList2 = leimuList
				}

			},
			changeLeimu3(val){
				let leimuList = JSON.parse(JSON.stringify(this.oldleimuList3))
				if (val){
					this.leimuList3 = leimuList.filter(item =>{
						return (item.typeName.indexOf(val) > -1 || item.typeNameCn.indexOf(val) > -1)
					})
					this.selectdescId3 = ''
				} else {
					this.leimuList3 = leimuList
				}

			},
			//修改类目名称
			setAllLeimuName(level){
				if (level == 1){
					this.allLeimuName = this.seletObj1.categoryName + '(' + this.seletObj1.categoryNameCn + ')'
				} else if (level == 2){
					this.allLeimuName = this.seletObj1.categoryName + '(' + this.seletObj1.categoryNameCn + ')'
					this.allLeimuName = this.seletObj1.categoryName + '(' + this.seletObj1.categoryNameCn + ')' + ' > ' + this.seletObj2.categoryName + '(' + this.seletObj2.categoryNameCn + ')'
				} else if (level == 3){
					this.allLeimuName = this.seletObj1.categoryName + '(' + this.seletObj1.categoryNameCn + ')' + ' > ' + this.seletObj2.categoryName + '(' + this.seletObj2.categoryNameCn + ')' + ' > ' + this.seletObj3.typeName + '(' + this.seletObj3.typeNameCn + ')'
				} else {
					this.allLeimuName = ''
				}

			},
			//搜索分类名称
			searchFenlei(){
				if (new Date().getTime() - this.changeFenleiTime < 1000){
                    return;
				}
				this.changeFenleiTime = new Date().getTime()
				this.isSearch =true
				if (!this.formData.searchName) {
					return
				}
				const API = Baseurl + 'ozonCategoryController/selectOzonCategoryByName'
				const paramsData = {
					name: this.formData.searchName,
				}
				ajaxPost(API, paramsData)
						.then((res) => {
							const { code, data,message } = res.data
							if (code === 200) {
								this.leimuList4 = data
							} else {
								this.$message.error(message)
							}
						})
						.catch((e) => {
							this.$message.error('查找失败')
						})

			},
			//重置
			resetFenlei(){
				this.isSearch = false
				this.formData.searchName = ''

			},
			//根据商品类型获取属性及属性值   attrList 变体属性  zhuAttributes 主属性
			getAttribute(attrList,isBian,zhuAttributes,biantizhi){
				this.loading  = this.$loading({
					target: this.$refs.dia_box,
					text: '努力加载中...',
					background: 'rgba(218,218,238,0.2)'
				})
				const API = Baseurl + 'ozonCategoryController/getAttributeAndValues'
				const paramsData = {
					descriptionCategoryId: this.formData.categoryId,//分类id 服装>>服装
					typeId: this.formData.typeId, //商品类型id 运动衫
				}
				ajaxPost(API, paramsData)
						.then((res) => {
							const code = res.data.code;
							const message = res.data.code;
							const data = res.data.data ? res.data.data : [];
							if(data.length == 0){
								this.$message.error('所选分类没有属性，请更换');
							}
							if (code === 200) {
								this.attr9048 = undefined;
								this.attr8292 = undefined;

								this.oldAttributeList = data.filter(item => {
									//固定写法
									if(item.attributeId == '31' || item.attributeId == '85'){
										item.fieldValue = '无品牌'
										item.dictionaryId = 0
									}
									if(item.attributeId == '33'){
										item.fieldValue = '无系列'
										item.dictionaryId = 0
									}
									//文字描述 简介
									if(item.attributeId == '4191'){
										this.biaotiComplexId4191 = item.attributeComplexId
										//父组件调用修改描述信息
										this.$emit('editDescJson', item.descriptionCn,'jianjie')
									}
									//尺寸表id=13164的显示尺寸表填写内容
									if(item.attributeId == '13164'){
										this.biaotiComplexId13164 = item.attributeComplexId
										//父组件调用修改描述信息
										this.$emit('editDescJson', item.descriptionCn,'chicunbiao')
									}
									//尺寸表id=11254 JSON 丰富内容
									if(item.attributeId == '11254'){
										this.biaotiComplexId11254 = item.attributeComplexId
										//父组件调用修改描述信息
										this.$emit('editDescJson', item.descriptionCn,'jsonFenfu')
									}
									//视频标题
									if(item.attributeId == '21837'){
										this.biaotiComplexId21837 = item.attributeComplexId
										//父组件调用修改描述信息
										this.$emit('editShipinDesc', item.descriptionCn,'biaoti')
									}
									//产品视频
									if(item.attributeId == '21841'){
										this.biaotiComplexId21841 = item.attributeComplexId
										//父组件调用修改描述信息
										this.$emit('editShipinDesc', item.descriptionCn,'chanpin')
									}
									//封面视频
									if(item.attributeId == '21845'){
										this.biaotiComplexId21845 = item.attributeComplexId
										//父组件调用修改描述信息
										this.$emit('editShipinDesc', item.descriptionCn,'fengmian')
									}
									// if (this.addStatus == 'add'){
									//
									// 	// if (item.attributeId == '4180'){
									// 	// 	this.biaotiComplexId4180 = item.attributeComplexId
									// 	// }
									// }
									if (item.attributeId == '9048'){
										this.biaotiComplexId9048 = item.attributeComplexId
										this.attr9048 = item
									}

									if (item.attributeId == '8292'){
										this.biaotiComplexId8292 = item.attributeComplexId
										this.attr8292 = item
									}
									return (item.attributeId != '13164' && item.attributeId != '11254'  && item.attributeId != '4191'   //json
											&& item.attributeId != '21837' && item.attributeId != '21841'&& item.attributeId != '21845' //视频
											//	&& item.attributeId != '4180' //标题
											&& item.attributeId != '9048' && item.attributeId != '8292') //合并型号，页面不显示，
								})
								//新增逻辑 或者没有保存变体
								if (this.addStatus == 'add' || isBian == 'wubianti' || this.isEditLeimu){
									this.topAttributeList = this.oldAttributeList.filter(item => {
										return item.isAspect == '0'
									})
									//1 为变体
									this.bottomAttributeList = this.oldAttributeList.filter(item => {
										return item.isAspect == '1'
									})
									this.setBiantiList()

								} else {
									let zhuShuList = []
									let biantiList = []
									let arr1 = []
									biantizhi.forEach(item =>{
										let tableArr= []
										if (item.aspectAttributes && item.aspectAttributes.length > 0){

											item.aspectAttributes.forEach(aaItem => {
												this.oldAttributeList.forEach(oldAtrItem =>{
													if (oldAtrItem.attributeId == aaItem.id){
														//输入框
														if (oldAtrItem.dictionaryId == 0){
															if (oldAtrItem.type == 'Boolean'){
																tableArr.push({
																	value:aaItem.values.length > 0 ? (aaItem.values[0].value == true ? true:false) : false
																})
															} else {
																tableArr.push({
																	value:aaItem.values.length > 0 ? aaItem.values[0].value : undefined
																})
															}
														}
														//单选
														if (oldAtrItem.dictionaryId != 0 && oldAtrItem.isCollection == 0){
															tableArr.push({
																value:aaItem.values.length > 0 ? aaItem.values[0].value : undefined
															})
														}
														//多选
														if (oldAtrItem.dictionaryId != 0 && oldAtrItem.isCollection == 1) {
															tableArr.push({
																value:aaItem.values.map(itemMap =>{
																	return itemMap.value
																})
															})
														}
													}

												})
											})
										}
										arr1.push(tableArr)
									})
									//编辑的时候从属性组获取
									this.oldAttributeList.filter(item =>{
										//自身是变体属性或者 属性id包含在传过来的变体数组内
										// 编辑不再考虑  item.isAspect == '1' ||
										if(attrList.some(itemSome =>{
											// if (itemSome.id == item.attributeId){
											// 	//输入框
											// 	if(item.dictionaryId == 0){
											// 		item.fieldValue = itemSome.values.length > 0 ? itemSome.values[0].value : undefined
											// 	}
											// 	//单选
											// 	if (item.dictionaryId != 0 && item.isCollection == 0){
											// 		item.fieldValue = itemSome.values.length > 0 ? itemSome.values[0].value : undefined
											// 	}
											// 	//多选
											// 	if (item.dictionaryId != 0 && item.isCollection == 1) {
											// 		item.fieldValue = itemSome.values.map(itemMap =>{
											// 			return itemMap.value
											// 		})
											// 	}
											// }
											return itemSome.id == item.attributeId
										})) {
											biantiList.push(item)
										} else {
											zhuAttributes.forEach(itemSome =>{
												if (itemSome.id == item.attributeId){
													//输入框
													if(item.dictionaryId == 0){
														if (item.dictionaryId == 0){
															if (item.type == 'Boolean'){
																item.fieldValue =  itemSome.values.length > 0 ? (itemSome.values[0].value == true ? true:false) : false
															} else {
																item.fieldValue =  itemSome.values.length > 0 ? itemSome.values[0].value : undefined
															}
														}
													}
													//单选
													if (item.dictionaryId != 0 && item.isCollection == 0){
														item.fieldValue =  itemSome.values.length > 0 ? itemSome.values[0].value : undefined
													}
													//多选
													if (item.dictionaryId != 0 && item.isCollection == 1) {
														item.fieldValue = itemSome.values.map(itemMap =>{
															return itemMap.value
														})
													}
												}
											})
											zhuShuList.push(item)
										}
									})
									this.topAttributeList = JSON.parse(JSON.stringify(zhuShuList))
									this.bottomAttributeList = JSON.parse(JSON.stringify(biantiList))
									if (this.addStatus == 'add' || isBian == 'wubianti' || this.isEditLeimu){
										this.setBiantiList()
									} else {
										this.setBiantiList2(arr1)
									}
								}
								this.loading.close()
							} else {
								this.oldAttributeList = [];
								this.loading.close()
								this.$message.error(message)
							}
						})
						.catch((e) => {
							this.oldAttributeList = [];
							this.loading.close()
							this.$message.error('查找失败')
						})
			},
			//根据商品类型获取属性及属性值   zhuAttributes 主属性值
			getOnlineAttribute(zhuAttributes){
				this.loading  = this.$loading({
					target: this.$refs.dia_box,
					text: '努力加载中...',
					background: 'rgba(218,218,238,0.2)'
				})
				const API = Baseurl + 'ozonCategoryController/getAttributeAndValues'
				const paramsData = {
					descriptionCategoryId: this.formData.categoryId,//分类id 服装>>服装
					typeId: this.formData.typeId, //商品类型id 运动衫
				}
				ajaxPost(API, paramsData)
						.then((res) => {
							const { code, data,message } = res.data
							if (code === 200) {
								this.attr9048 = undefined
								this.attr8292 = undefined
								this.oldAttributeList = data.filter(item => {
									//文字描述 简介
									if(item.attributeId == '4191'){
										this.biaotiComplexId4191 = item.attributeComplexId
										//父组件调用修改描述信息
										this.$emit('editDescJson', item.descriptionCn,'jianjie')
									}
									//尺寸表id=13164的显示尺寸表填写内容
									if(item.attributeId == '13164'){
										this.biaotiComplexId13164 = item.attributeComplexId
										//父组件调用修改描述信息
										this.$emit('editDescJson', item.descriptionCn,'chicunbiao')
									}
									//尺寸表id=11254 JSON 丰富内容
									if(item.attributeId == '11254'){
										this.biaotiComplexId11254 = item.attributeComplexId
										//父组件调用修改描述信息
										this.$emit('editDescJson', item.descriptionCn,'jsonFenfu')
									}
									//视频标题
									if(item.attributeId == '21837'){
										this.biaotiComplexId21837 = item.attributeComplexId
										//父组件调用修改描述信息
										this.$emit('editShipinDesc', item.descriptionCn,'biaoti')
									}
									//产品视频
									if(item.attributeId == '21841'){
										this.biaotiComplexId21841 = item.attributeComplexId
										//父组件调用修改描述信息
										this.$emit('editShipinDesc', item.descriptionCn,'chanpin')
									}
									//封面视频
									if(item.attributeId == '21845'){
										this.biaotiComplexId21845 = item.attributeComplexId
										//父组件调用修改描述信息
										this.$emit('editShipinDesc', item.descriptionCn,'fengmian')
									}
									//固定写法
									if(item.attributeId == '31' || item.attributeId == '85'){
										item.fieldValue = '无品牌'
										item.dictionaryId = 0
									}
									if(item.attributeId == '33'){
										item.fieldValue = '无系列'
										item.dictionaryId = 0
									}
									if (item.attributeId == '9048'){
										this.biaotiComplexId9048 = item.attributeComplexId
										this.attr9048 = item
									}

									if (item.attributeId == '8292'){
										this.biaotiComplexId8292 = item.attributeComplexId
										this.attr8292 = item
									}
									return (item.attributeId != '13164' && item.attributeId != '11254'  && item.attributeId != '4191'   //json
											&& item.attributeId != '21837' && item.attributeId != '21841'&& item.attributeId != '21845' //视频
											//	&& item.attributeId != '4180' //标题
											&& item.attributeId != '9048' && item.attributeId != '8292') //合并型号，页面不显示，
								})
								let topList = []
								this.oldAttributeList = this.oldAttributeList.map(item =>{
									// //输入框
									// if (item.dictionaryId == 0){
									// 	item.fieldValue = ''
									// }
									// //单选
									// if (item.dictionaryId != 0 && item.isCollection == 0){
									// 	item.fieldValue = ''
									// }
									// //多选
									// if (item.dictionaryId != 0 && item.isCollection == 1){
									// 	item.fieldValue = []
									// }
									zhuAttributes.forEach(itemSome => {
										if (itemSome.attribute_id == item.attributeId){
											if (item.dictionaryId == 0){
												if (item.type == 'Boolean'){
													item.fieldValue = itemSome.values.length > 0 ? (itemSome.values[0].value == true ? true:false) : undefined
												} else {
													item.fieldValue = itemSome.values.length > 0 ? itemSome.values[0].value : undefined
												}
											}
											//单选
											if (item.dictionaryId != 0 && item.isCollection == 0){
												item.fieldValue =  itemSome.values.length > 0 ? itemSome.values[0].value : undefined
											}
											//多选
											if (item.dictionaryId != 0 && item.isCollection == 1){
												item.fieldValue = itemSome.values.map(itemMap =>{
													return itemMap.value
												})
											}
										}
									})
									if (item.isAspect == '0'){
										topList.push(item)
									}
									return item
								})
								this.topAttributeList = JSON.parse(JSON.stringify(topList))
								//1 为变体
								this.bottomAttributeList = this.oldAttributeList.filter(item => {
									return item.isAspect == '1'
								})
								 this.setBiantiList3()
								this.loading.close()
							} else {
								this.$message.error(message)
							}
						})
						.catch((e) => {
							this.$message.error('查找失败')
						})
			},
			handleSelectleimu(){
				this.leimuDialog = false
				this.getAttribute()
			},
			//生成sku编号
			createSku(){
				const paramsData = {
					staffId:this.staffId
				}
				const API = Baseurl + '/commonSettingController/getCommonSettingByStaffId'
				ajaxPost(API, paramsData)
						.then((res) => {
							if(res.data.code === 200) {
								this.formData.sku = res.data.data.sku
								this.$emit('changeSku',this.formData.sku)
							}else{
								this.$message.error(res.data.data)
							}
						})
			},
			inputSkuchange(val){
				if (val){
					this.$emit('changeSku',val)
				}
			},
			inputNamechange(val){
				if (val){
					this.$emit('changeName',val)
				}
			},

			//首字母大写
			capitalizeFirstLetter() {
				this.formData.name = (this.formData.name.toLowerCase().replace(/\b[a-z]/g, function(match) {
					return match.toUpperCase();
				}))
			},
			//设置变体
			setBiantiList(){
				this.$emit('setBiantiList',this.bottomAttributeList)
			},

			//设置变体
			setBiantiList2(list){
				this.$emit('setBiantiList2',this.bottomAttributeList,list)
			},
			//在线产品设置变体
			setBiantiList3(){
				this.$emit('setBiantiList3',this.bottomAttributeList)
			},
			//增加下面移除的变体
			addTopAttrList(attrList){
				this.topAttributeList = this.topAttributeList.concat(attrList)
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import "../ozon.less";
	.shuxing_box{
		min-height: 100px;
		background: rgb(238,238,238);
		border-radius: 10px;
		width: 88%;
		float: left;
		padding: 10px 0;
		font-size: 16px;
		.item_shuxing{
			display: flex;
			margin-bottom: 4px;
			.shuxing_label{
				width: 40%;
				text-align: right;
				padding: 3px 10px;
				.shuxing_label_bitian{
					color: red;
					margin-right: 4px;
				}
			}
			.shuxing_input{
				width: 100%;
			}
			.shuxing_select{
				width: 100%;
			}
			.shuxing_button{
				width: 30px;
				height: 30px;
				padding: 0;
				display: flex;
				align-items: center;
				justify-content: center;
				background: rgb(255,183,82);
				color: white;
				font-weight: 700;
				font-size: 20px;
				margin-left: 10px;
			}
		}
	}
	.input_bot_tip{
		display: flex;
		flex-direction: column;
	}
	.search_box{
		padding: 15px 10px;
		width: calc(100% - 20px);
		background: rgb(238,238,238);
		margin-top: 10px;
		display: flex;
		.search_box_item{
			width: 30%;
			margin-right: 20px;
			.leimu_box{
				height: 400px;
				padding: 10px;
				overflow-y: auto;
				background: white;
				.leimu_item{
					display: flex;
					justify-content: space-between;
					align-items: center;
					cursor: pointer;
					padding: 5px 0;
					font-size: 16px;
					.leimu_item_desc{
						width:calc(100% - 20px);
						white-space: nowrap;      /* 确保文本在一行内显示 */
						overflow: hidden;         /* 隐藏溢出的内容 */
						text-overflow: ellipsis;
					}
					.item_leimu_you{
						color: rgb(82,190,166);
						margin-top: 3px;
					}
				}
				.select_leimu {
					border: 1px solid rgb(82,190,166);
					box-sizing: content-box;
				}
				.leimu_item:hover{
					border: 1px solid rgb(82,190,166);
					color: rgb(82,190,166);
					box-sizing: content-box;
				}
			}
		}

	}

	.search_box2{
		padding: 15px 0px 15px 2px;
		width: calc(100%);
		background: rgb(238,238,238);
		margin-top: 10px;
	}
	.leimu_box2{
		height: 400px;
		padding: 10px;
		overflow-y: auto;
		background: white;
		width: calc(100% - 20px);
		.leimu_item{
			display: flex;
			justify-content: space-between;
			align-items: center;
			cursor: pointer;
			padding: 7px 0;
			font-size: 14px;
			.leimu_item_desc{
				width:calc(100% - 20px);
				white-space: nowrap;      /* 确保文本在一行内显示 */
				overflow: hidden;         /* 隐藏溢出的内容 */
				text-overflow: ellipsis;
			}
			.item_leimu_you{
				color: rgb(82,190,166);
				margin-top: 3px;
			}
		}
		.select_leimu {
			border: 1px solid rgb(82,190,166);
			box-sizing: content-box;
		}
		.leimu_item:hover{
			border: 1px solid rgb(82,190,166);
			color: rgb(82,190,166);
			box-sizing: content-box;
		}
	}
	.item_img{
		height: 16px;
		width: 16px;
		margin-left: 5px;
		cursor: pointer
	}
	.el_tip_box{
		width: 360px;
		font-size: 16px;
		background: rgb(39,39,39);
		border-radius: 10px;
		padding: 8px;
		color: whitesmoke;

	}
</style>
